// Client helpers for the early-access request flow.
// Security decisions are enforced server-side; these helpers only assemble
// the approved submission contract.

let memorySessionId = null;
const SESSION_KEY = "culmora_session_id";
const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function getSessionId() {
  try {
    let id = window.sessionStorage.getItem(SESSION_KEY);
    if (!id || !UUID_RE.test(id)) {
      id = createId();
      window.sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    if (!memorySessionId) memorySessionId = createId();
    return memorySessionId;
  }
}

export function resetSessionId() {
  const id = createId();
  try {
    window.sessionStorage.setItem(SESSION_KEY, id);
  } catch {
    memorySessionId = id;
  }
  return id;
}

function createId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  const bytes = new Uint8Array(16);
  if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
    crypto.getRandomValues(bytes);
  } else {
    for (let index = 0; index < bytes.length; index += 1) {
      bytes[index] = Math.floor(Math.random() * 256);
    }
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0"));
  return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${
    hex.slice(6, 8).join("")
  }-${hex.slice(8, 10).join("")}-${hex.slice(10).join("")}`;
}

export function getUtmParams() {
  const out = {};
  try {
    const params = new URLSearchParams(window.location.search);
    for (const key of ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"]) {
      const value = params.get(key);
      if (value) out[key] = value.slice(0, 200);
    }
  } catch {
    // no URL context (tests) — return empty
  }
  return out;
}

export function getLocale() {
  try {
    return (navigator.language || "en").slice(0, 16);
  } catch {
    return "en";
  }
}

export function getPagePath() {
  try {
    return window.location.pathname.slice(0, 200) || "/";
  } catch {
    return "/";
  }
}

export async function submitEarlyAccess(url, payload, { timeoutMs = 15000 } = {}) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      signal: controller.signal,
    });
    let body = null;
    try {
      body = await res.json();
    } catch {
      body = null;
    }
    return { status: res.status, body };
  } finally {
    clearTimeout(timer);
  }
}
